import { render, staticRenderFns } from "./TheHelpMenu.vue?vue&type=template&id=0cabfc37&scoped=true"
import script from "./TheHelpMenu.vue?vue&type=script&lang=js"
export * from "./TheHelpMenu.vue?vue&type=script&lang=js"
import style0 from "./TheHelpMenu.vue?vue&type=style&index=0&id=0cabfc37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cabfc37",
  null
  
)

export default component.exports